import React, { useState } from "react";
import styled from "@emotion/styled";
import { Link } from "react-router-dom";
import Logo from "../../images/lingdon-LOGO.svg";
import NavItems from "./NavItems";
import { color } from "../../styles/color";

const Outter = styled.div`
  display: flex;
  flex-flow: row nowrap;
  width: 90%;
  margin: 0 auto;
  align-items: center;
  padding: 1rem 0;
  position: relative;

  @media print {
    display: none;
  }
  a {
    display: flex;
    flex-flow: row nowrap;
    white-space: nowrap;
    align-items: center;
  }
  .imgContainer {
    margin-right: 0.5rem;
    position: relative;
    width: 2.2rem;
    height: 2.2rem;
    overflow: hidden;
    &:before {
      content: "";
      padding-top: 100%;
    }
    .logo {
      position: absolute;
      top: 0%;
      left: 0%;
      right: 0%;
      bottom: 0%;
      background-position: center;
      background-size: contain;
      background-repeat: no-repeat;
      background-image: url(${Logo});
    }
  }
  .brand {
    font-size: 1rem;
    letter-spacing: 0.2rem;
    color: ${color.primaryBlue};
    margin-right: 1rem;
    font-weight: 800;
  }
  @media (min-width: 768px) {
    .imgContainer {
      width: 2.5rem;
    }
  }
`;

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <Outter>
      <Link to="/">
        <div className="imgContainer">
          <div className="logo"></div>
        </div>
        <div className="brand">岭东资讯</div>
      </Link>
      <NavItems open={open} setOpen={setOpen} />
    </Outter>
  );
};

export default Navbar;
